import { render, staticRenderFns } from "./virtual.vue?vue&type=template&id=b6716052&scoped=true&"
import script from "./virtual.vue?vue&type=script&lang=js&"
export * from "./virtual.vue?vue&type=script&lang=js&"
import style0 from "./virtual.vue?vue&type=style&index=0&id=b6716052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6716052",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsBreadcrumbs: require('/var/web/bet777.es/components/elements/breadcrumbs.vue').default,SportIcon: require('/var/web/bet777.es/components/sport/icon.vue').default,ElementsVideo: require('/var/web/bet777.es/components/elements/video.vue').default})
